import { useTranslation } from "react-i18next";
import { PiPlusBold } from "react-icons/pi";
import { Button } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";

import { formatDateToString } from "@utils/dateValidation";
import { truncateWithEllipsis } from "@utils/truncateText";

import { PatientSurgicalHistoryItem } from "@customTypes/patient";

import { AddSurgicalHistoryModal } from "../AddSurgicalHistoryModal";
import { FullSurgicalHistoryModal } from "../FullSurgicalHistoryModal";

import { StyledSurgicalHistoryCard } from "./SurgicalHistoryCard.styled";


interface SurgicalHistoryCardProps {
  surgeries: PatientSurgicalHistoryItem[];
}

export const SurgicalHistoryCard = ({
  surgeries = [],
}: SurgicalHistoryCardProps) => {
  const { t } = useTranslation();
  const [fullModalOpened, { open: fullModalOpen, close: fullModalClose }] =
    useDisclosure(false);
  const [addModalOpened, { open: addModalOpen, close: addModalClose }] =
    useDisclosure(false);

  return (
    <StyledSurgicalHistoryCard>
      <AddSurgicalHistoryModal opened={addModalOpened} close={addModalClose} />
      <div className="card-header">
        <p className="heading">{t("surgical-history")}</p>
        <button onClick={addModalOpen} type="button">
          <PiPlusBold className="plus-icon" />
        </button>
      </div>
      <ul className="timeline">
        {surgeries.length > 0 ? (
          surgeries.slice(0, 2)?.map(({ date, surgery, id }) => (
            <li className="timeline-item" key={id}>
              <span className="date">{formatDateToString(date).slice(-7)}</span>
              <span aria-hidden className="decor"></span>
              <span className="name">{truncateWithEllipsis(surgery, 25)}</span>
            </li>
          ))
        ) : (
          <p className="empty-label">{t("empty-surgical-history")}</p>
        )}
      </ul>

      <div className="card-footer">
        <FullSurgicalHistoryModal
          surgeries={surgeries}
          opened={fullModalOpened}
          close={fullModalClose}
        />
        <Button
          type="button"
          onClick={fullModalOpen}
          variant="transparent"
          disabled={surgeries?.length < 1}
          size="compact-sm">
          {t("view-full-history")}
        </Button>
      </div>
    </StyledSurgicalHistoryCard>
  );
};
